/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LetterType = "MASS" | "NONE" | "SINGLE" | "%future added value";
export type CreateLetterMutationMutationVariables = {|
  companyId: string,
  companyLayoutId: number,
  letterType: LetterType,
|};
export type CreateLetterMutationMutationResponse = {|
  +Me: ?{|
    +Company: ?{|
      +businessPost: ?{|
        +data: ?{|
          +id: string,
          +tableId: number,
        |}
      |}
    |}
  |}
|};
export type CreateLetterMutationMutation = {|
  variables: CreateLetterMutationMutationVariables,
  response: CreateLetterMutationMutationResponse,
|};
*/


/*
mutation CreateLetterMutationMutation(
  $companyId: ID!
  $companyLayoutId: Int!
  $letterType: LetterType!
) {
  Me {
    Company(id: $companyId) {
      businessPost {
        data: createLetter(companyLayoutId: $companyLayoutId, letterType: $letterType) {
          id
          tableId
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyLayoutId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "letterType"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutations",
    "kind": "LinkedField",
    "name": "Me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "companyId"
          }
        ],
        "concreteType": "CompanyMutations",
        "kind": "LinkedField",
        "name": "Company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessPostMutation",
            "kind": "LinkedField",
            "name": "businessPost",
            "plural": false,
            "selections": [
              {
                "alias": "data",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "companyLayoutId",
                    "variableName": "companyLayoutId"
                  },
                  {
                    "kind": "Variable",
                    "name": "letterType",
                    "variableName": "letterType"
                  }
                ],
                "concreteType": "Letter",
                "kind": "LinkedField",
                "name": "createLetter",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tableId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateLetterMutationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateLetterMutationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc28d61d6d7253644e9ab169362b52a4",
    "id": null,
    "metadata": {},
    "name": "CreateLetterMutationMutation",
    "operationKind": "mutation",
    "text": "mutation CreateLetterMutationMutation(\n  $companyId: ID!\n  $companyLayoutId: Int!\n  $letterType: LetterType!\n) {\n  Me {\n    Company(id: $companyId) {\n      businessPost {\n        data: createLetter(companyLayoutId: $companyLayoutId, letterType: $letterType) {\n          id\n          tableId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a33bfb5ccc299641ecfd17acfcc7734b';

module.exports = node;
